import React, { useState, HTMLAttributes } from "react";
import StyledDrawer from "./MobileMenu.styled";
import HR from "../../atoms/HR/HR.styled";
import MenuItem from "../MenuItem";
import AppBar from "../AppBar";

export interface IMobileMenu extends HTMLAttributes<HTMLTableElement> {
  /** Full width menu */
  fullWidth?: boolean;
  /** Set Menu width config */
  width?: number;
  /** Menu items list */
  list: Array<any>;
  /** Menu items list */
  adminList?: Array<any>;
  /**
   * subtitle
   */
  subtitle?: string;
  /**
   * logoClickHandler
   */
  logoClickHandler?: () => void;
  profileElement?: JSX.Element;
}

const MobileMenu = ({
  list,
  adminList,
  logoClickHandler,
  profileElement,
}: IMobileMenu) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <AppBar
        logoClickHandler={logoClickHandler}
        isMenuOpened={isOpen}
        onMenuClick={() => setIsOpen(!isOpen)}
        profileElement={profileElement}
      />
      <StyledDrawer open={isOpen} onClose={() => setIsOpen(false)} anchor="top">
        <div>
          {list.map((item) => (
            <MenuItem
              Icon={item.Icon}
              label={item.text}
              to={item.link}
              spacing={0}
              onClick={() => setIsOpen(false)}
            />
          ))}
        </div>
        {adminList && adminList.length ? (
          <>
            <HR />
            <div>
              {adminList.map((item) => (
                <MenuItem
                  Icon={item.Icon}
                  label={item.text}
                  to={item.link}
                  spacing={0}
                  onClick={() => setIsOpen(false)}
                />
              ))}
            </div>
          </>
        ) : null}
      </StyledDrawer>
    </div>
  );
};

export default MobileMenu;
